
import React, { useEffect, useState, useRef } from "react";
import "./ConversationCard.css";
import { StarOutlined, StarFilled } from "@ant-design/icons";
import { Badge, Avatar, Tooltip } from "antd";
import moment from "moment";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import history from "../../../../routes/history";
import {
  fetchChatHistory,
  receivedMessage,
  addMessageFavorites,
  removeMessageFavorites,
  messagesJobDetails,
  clearEditOfferRes,
  addMessageToFavourite,
  removeMessageFromFavourite,
} from "../../../../redux/actions";
import WS from "../../../../webSocket/defaultSocket";
import { smoothBezier } from "@antv/g2plot/lib/utils/path";
// import { trimStart } from 'lodash';

export default function ConversationCard({
  records,
  setLoadChat,
  setshowHistory,
  setRecipient,
  setTitle,
  setCreatedTime,
  setItemId,
  favCard,
  setJobTitle,
  title,
  setJobDetails,
  selectedChat,
  setSelectedChat,
  SourceName,
  // data
  SourceId, 
  fromNotificationScreen,
  conversationId,
  Index,
  Recipient,
}) {
  // const [dp, setDp] = useState();
  const [unRead, setunRead] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fav, setFav] = useState(false);
  const [favClicked,setfavClicked] =useState();
  const [hasError, setHasError] = useState(false);
  // const [jobTitle, setGigTitle] = useState(false);

  const dispatch = useDispatch();
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const favouriteRed = useSelector((state) => state?.conversationFavReducer); 
  const inbox = useSelector((state) => state.messagesReducer.inbox);
  const [time, setTime] = useState(moment(records?.Created).fromNow());
  const [chatIndex,setChatIndex] = useState();

  const [imageError, setImageError] = useState(false);
  const [empImageError, setEmpImageError] = useState(false);

  const notification = useSelector(
    (state) => state.fetchNotificationReducer.notification
  );

  const privateids = notification[0]?.senderprofile[0]?.EmployeeAssociation
  let isPrivate = false;

  // const tmp1 = localStorage.getItem("profilePicture");
  // const recipientProfileImg = JSON.parse(tmp1);
  const tmp = localStorage.getItem("userProfile");
  const tmp2 = JSON.parse(tmp);
  const recipientProfileName = tmp2?.Profiles?.FirstName;
  const recipientProfileImg = tmp2?.Profiles?.PictureUrl;

  useEffect(() => {
      setLoading(favouriteRed?.loading);
      setfavClicked(favouriteRed?.loading)
      if(!favouriteRed?.loading){
        setChatIndex(null)
      }
  }, [favouriteRed?.loading]);

  useEffect(() => {
    if(records && privateids)
    {
      const senderId = records?.SenderUserId;
      isPrivate = privateids?.includes(records?.SenderUserId);
      // privateids.includes(records?.SenderUserId)
    }

  }, [records, privateids])

  useEffect(() => {
    setTime(moment(records?.Created).fromNow());
    const hoursDifference = moment().diff(moment(records?.Created), 'hours');
    if(hoursDifference < 25){ //for only last 24 hours chats
      const interval = setInterval(() => {
        setTime(moment(records?.Created).fromNow());
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [records?.Created]);

  useEffect(() => {
    setFav(records?.IsFavorite);
  }, [records?.IsFavorite]);

  useEffect(() => {
    setunRead(false);
  }, [records]);

  
  const [socketConnected, setSocketConnected] = useState(false);
  const handleFavourite = () => {
    setChatIndex(Index);
    setLoading(!loading);
    setfavClicked(true);
    if (!fav || !records?.IsFavorite) {
      dispatch(
        addMessageToFavourite({
          SourceName,
          SourceId,
          Index
        })
        );
        setFav(true);
      } else {
        dispatch(
          removeMessageFromFavourite({
          SourceId,
          SourceName,
          Index
        })
      );
      setFav(false)
    }

    // setFav(!fav);
    // records?.IsFavorite
    //   ? dispatch(
    //       removeMessageFavorites({
    //         SourceId,
    //         SourceName,
    //       })
    //     )
    //   : dispatch(
    //       addMessageFavorites({
    //         SourceName,
    //         SourceId,
    //       })
    //     );
  };


  // useEffect(async () => {
  //   let profilePic = "";
  //   if (records?.SenderUserPictureUrl) {
  //     profilePic = await getImage(records?.SenderUserPictureUrl);
  //   }
  //   setDp(profilePic);
  // }, [records]);
  useEffect(() => {
    if (setRecipient) {
      setRecipient(records?.SenderUserName);
    }
    let title = "Gig title";

    if (records?.SourceTypeId == 1) {
      title = records?.SkillListing?.Title;

      if (setTitle) {
        setTitle(title);
      }
    } else if (records?.SourceTypeId == 2) {
      title = records?.GigCard?.Title;
      setTitle(title);
    } else {
      title = "User name";
    }
  }, [records, title]);

  //********** convert encrypted html code to HTML tags **********
  var cache = {},
    character,
    e = document.createElement("div");

  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
          character = cache[entity] = e.childNodes[0].nodeValue;
        else character = "";
      }

      return character;
    });
  };

  return (
    <div
      className="conversation-card"
      onClick={() => {
        setunRead(true);
        if (setLoadChat) setLoadChat(true);
        setshowHistory(true);
        setCreatedTime(records?.Created);
        setItemId(records?._id);
        setSocketConnected(true);
        dispatch(clearEditOfferRes());
        if(history.location.pathname.includes("conversations")){
          history.replace({
            pathname: `/conversations/${records._id}`,
            state: {
              openConvo: true,
              conversationId: records._id,
              records : records,
              SourceName: SourceName,
              SourceId: SourceId,
              Index:Index,
              // jobtitle: item.JobTitle,
            },
          });
        }else{

          history.push({
            pathname: `/conversations/${records._id}`,
            state: {
              openConvo: true,
              conversationId: records._id,
              records : records,
              SourceName: SourceName,
              SourceId: SourceId,
              Index:Index,
              // jobtitle: item.JobTitle,
            },
          });
        }

      }}
      style={{ backgroundColor: selectedChat == records._id && "#e4ffec" }}
      key={records._id}
    >
      <div
        className="conversation-card-star"
        onClick={(e) => {
          e.stopPropagation();
          handleFavourite();
        }}
      >
        {/* {!loading ? (
          // (fav  == false ||   favCard == false)
          (fav  == false)
           ? (
            <StarOutlined style={{ fontSize: "22px", color: "#aaaaaa" }} />
          ) : (
            <StarFilled style={{ fontSize: "22px", color: "#ffba08" }} />
          )
        ) : (
          (inbox?.data?.data?.body?.conversations[chatIndex]?._id == records?._id) &&
          <LoadingOutlined />
        )} */}
        
        {inbox?.data?.data?.body?.conversations[chatIndex]?._id == records?._id && loading ? 
          <LoadingOutlined />
          :
          (fav  == false)
           ? (
            <StarOutlined style={{ fontSize: "22px", color: "#aaaaaa" }} />
          ) : (
            <StarFilled style={{ fontSize: "22px", color: "#ffba08" }} />
          )
        }
        </div>
      {/* <div className="testing-class"> */}
      <div onClick={(e) => { e.stopPropagation(); e.preventDefault() }} className="conversation-card-image">
        {userProfile?.EmployeeAssociation?.includes(records?.SenderUserId) &&
          <div className="conversation-card-emp-image2">
            {recipientProfileImg && !empImageError && recipientProfileImg?.split("/")?.pop() !== "no-pic.png" ? (
              <img
                onError={() => {
                  setEmpImageError(true);
                }}
                style={{ width: "100%", maxHeight:'24px'}} //width: "100%",
                src={`${process.env.REACT_APP_S3_URL}${recipientProfileImg?.charAt(0) !== "/" ? "/" : ""
                  }${recipientProfileImg}`}
                alt="pvt"
              />
            ) : (
              <div className="image-container22">
                <div className="image-text2">
                  {recipientProfileName?.split("")[0]?.toUpperCase()}
                </div>
              </div>
            )}
          </div>
        }
          {records?.SenderUserPictureUrl && !imageError && records?.SenderUserPictureUrl?.split("/")?.pop() !== "no-pic.png" ? (
            <img
              onError={() => {
                setImageError(true);
              }}
              style={{ height: "100%", borderRadius: "50%", width: "inherit" }} //width: "100%",
              src={`${process.env.REACT_APP_S3_URL}${
                records?.SenderUserPictureUrl?.charAt(0) !== "/" ? "/" : ""
              }${records?.SenderUserPictureUrl}`}
            />
          ) : (
            <div className="image-container">
              <div className="image-text">
                {records?.SenderUserName?.split("")[0]?.toUpperCase()}
              </div>
            </div>
          )}
        </div>
        <div className="conversation-card-contentContainer">
          <Tooltip
            title={
              records?.SourceTypeId == 1
                ? records.SkillListing?.Title
                : records?.SourceTypeId == 2
                ? records.GigCard?.Title
                : ""
            }
          >
            <div style={{fontSize: '15px', color: 'black', fontWeight: '500', fontStretch: 'normal', textTransform: 'capitalize'}}>{records?.SenderUserName}</div>
            <div className="conversation-card-contentContainer-title">
              {records?.SourceTypeId == 1
                ? records?.skillListing?.Title ?? "Title Missing"
                : records?.JobTitle ?? "Title Missing"}
            </div>
          </Tooltip>
        <div className="conversation-card-contentContainer-message">
          {/* <Tooltip
            title={
              records?.MessageText
          } 
          >*/}
            <div
              style={{ overflow: "hidden", textOverflow:"ellipsis" ,maxWidth:"73vw" }}
              dangerouslySetInnerHTML={{
                __html:
                  (records?.SourceTypeId !== 1 && records?.MessageText) ===
                  "You placed a bid"
                    ? "Bid is Received"
                    : msgtxt(records?.MessageText),
              }}
            ></div>
            {/* </Tooltip> */}
            {/* {records?.MessageText?.length >= 17 && "..."} */}
          </div>
        </div>
      {/* </div> */}
      <div className="conversation-card-extraContent">
        <div className="conversation-card-extraContent-time">
          {time}
        </div>
        {records?.countUnRead > 0 &&
        !unRead &&
        selectedChat !== records._id &&
        userProfile?.AccountId != records?.SenderUserId ? ( //this needs to be handled using reducer
          <div className="conversation-card-extraContent-count">
            {records?.countUnRead}
          </div>
        ) : null}
      </div>
    </div>
  );
}
